import { render, staticRenderFns } from "./StadiumBoosts.vue?vue&type=template&id=144285e6&"
import script from "./StadiumBoosts.vue?vue&type=script&lang=js&"
export * from "./StadiumBoosts.vue?vue&type=script&lang=js&"
import style0 from "./StadiumBoosts.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144285e6')) {
      api.createRecord('144285e6', component.options)
    } else {
      api.reload('144285e6', component.options)
    }
    module.hot.accept("./StadiumBoosts.vue?vue&type=template&id=144285e6&", function () {
      api.rerender('144285e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoosts.vue"
export default component.exports